























































import { Component, Vue, Ref } from 'vue-property-decorator';
import SearchHeader from '@/components/SearchHeader.vue';
import Pagination from '@/components/Pagination.vue';
import { attachmentApis, AttachmentListRequest, AttachmentListResponse, Accessible } from '@/api/attachments.api';
import AttachmentNewDialog from './AttachmentNewDialog.vue';
import AttachmentCopyShardDialog from './AttachmentCopyShardDialog.vue';
import { formatterDatetime } from '@/common';

@Component({ components: { Pagination, SearchHeader, AttachmentNewDialog, AttachmentCopyShardDialog } })
export default class Attachments extends Vue {
  @Ref('copyAttachmentShard') copyAttachmentShard!: AttachmentCopyShardDialog;

  listParam: AttachmentListRequest = {
    page: 1,
    page_size: 20
  };
  listResult: AttachmentListResponse = {
    items: [],
    total: 0
  };
  loading = false;
  newDialogVisible = false;
  formatterDatetime = formatterDatetime;

  mounted() {
    this.getItemList();
  }

  async getItemList() {
    this.loading = true;
    try {
      const res = await attachmentApis.listMyAttachment(this.listParam);
      this.listResult = res;
    } finally {
      this.loading = false;
    }
  }

  formatterAccessible(accessible: string) {
    switch (accessible) {
      case Accessible.ALL:
        return '所有人';
      case Accessible.EMPLOYEE_ONLY:
        return '所有公司员工';
      case Accessible.RECIPIENTS_ONLY:
        return '是收件人并且是公司内部人';
      default:
        return '未知';
    }
  }

  isExpired(expireAt: string) {
    return new Date(expireAt) < new Date();
  }
}
